import styled from 'styled-components'

const FooterStyle = styled.section`
  display: flex;
  width: 100%;
  padding: 50px 0;
  margin-top: 70px;
  background: #007e78;

  @media(max-width: 800px) {
    > div {
      flex-direction: column;
    }

    padding: 25px 25px 170px 25px;
  }
`;

const FooterColumn = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;

  color: #fff;

  &.copyright {
    p {
      font-size: 13px;
    }
    ul {
      display: flex;
      margin: 30px 0;

      li {
        a {
          display: block;
          width: 27px;
          height: 27px;
          margin-right: 15px;
        }
      }
    }
  }

  &.links {
    width: 50%;

    ul li a {
      color: #fff;
      font-size: 14px;
      line-height: 3.21;
      text-decoration: underline;
    }
  }

  &.newsletter {
    h3 {
      color: #f2fff7;
      font-size: 18px;
      letter-spacing: normal;
      margin-bottom: 10px;
    }

    p {
      font-size: 13px;
      margin-bottom: 20px;
    }

    form {
      display: flex;
      height: 45px;

      input {
        width: 100%;
        color: #8a9ba5;
        font-size: 14px;
        padding: 13px 20px;
        border: none;
        letter-spacing: 1.68px;
        border-top-left-radius: 8px;
        border-top-right-radius: 0px;
        border-bottom-right-radius: 0px;
        border-bottom-left-radius: 8px;
      }
      button {
        width: 146px;
        height: 100%;
        color: #fff;
        background-color: #93da49 !important;
        border: 1px solid #93da49;
        border-top-left-radius: 0px;
        border-top-right-radius: 8px;
        border-bottom-right-radius: 8px;
        border-bottom-left-radius: 0px;
      }
    }
  }
`;

const FooterRow = styled.div`
  display: flex;
  width: 100%;
  margin-top: 70px;
  background: #007e78;
`;

const LogoFooter = styled.img`
  width: 150px;
`;

export { FooterStyle, LogoFooter, FooterColumn, FooterRow };
